var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39,19.5A19.5,19.5,0,1,1,19.5,0,19.5,19.5,0,0,1,39,19.5Z",
    fill: "none",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.23,12.1V8.53a1.18,1.18,0,0,1,1.25-1.07h8a1.17,1.17,0,0,1,1.25,1.07V12.1",
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    fillRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.12,
    y: 14.59,
    width: 10.77,
    height: 5.24,
    rx: 0.93,
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.32,
    y: 22.31,
    width: 2.23,
    height: 2.23,
    rx: 0.47,
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.39,
    y: 22.31,
    width: 2.23,
    height: 2.23,
    rx: 0.47,
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.45,
    y: 22.31,
    width: 2.23,
    height: 2.23,
    rx: 0.47,
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22.45,
    y: 26.24,
    width: 2.23,
    height: 2.23,
    rx: 0.47,
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 18.39,
    y: 26.24,
    width: 2.23,
    height: 2.23,
    rx: 0.47,
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.32,
    y: 26.24,
    width: 2.23,
    height: 2.23,
    rx: 0.47,
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.77,10.91a3.29,3.29,0,0,1,2.73,3.23V28.26a3.29,3.29,0,0,1-3.28,3.28H14.78a3.29,3.29,0,0,1-3.28-3.28V14.14a3.29,3.29,0,0,1,2.73-3.23",
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.926a1c2875702550a323dde8b1aa0323.svg";
export { ForwardRef as ReactComponent };